// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"84c6b402","285":"d6c2df0f"}[chunkId] + ".chunk.js";
};